<template>
    <v-app>
        
        <v-app-bar
                :height="$vuetify.breakpoint.mdAndUp ? 80 : 64"
                app
                elevate-on-scroll
                v-if="$route.meta.showHeader"
                color="#fff"
                class="py-0 my-0"
        >
        <v-container class="py-0 fill-height custom-container">
            <div class="d-flex align-center cursor-pointer">
                <v-img contain @click="$router.replace('/');" src="/general/logo-header.svg" :max-width="$vuetify.breakpoint.mdAndUp ? '240px' : '150px'"></v-img>
            </div>

            <v-spacer></v-spacer>
            <v-toolbar-items  class="py-0 my-0">
                
                
                    
                    <v-btn text to="/search-doctor?clinic=1" class="playfair-display hidden-sm-and-down" :class="addNavClasses('clinic')">
                        <div class="d-flex align-center justify-center flex-column">
                            <v-img                         
                                width="30"
                                height="30"                        
                                src="/general/ic_clinic_nav.png"
                            ></v-img>
                            <span class="mt-1">Clinic Consultation</span>
                        </div>
                    </v-btn>

                
                
                <v-btn text to="/video-consultation" class="playfair-display hidden-sm-and-down" :class="addNavClasses('video')">
                    <div class="d-flex align-center justify-center flex-column">
                            <v-img                         
                                width="30"
                                height="30"                        
                                src="/general/ic_video_nav.png"
                            ></v-img>
                            <span class="mt-1">Video Consultation</span>
                        </div>
                    
                </v-btn>
                <v-btn text class="playfair-display hidden-md-and-down" to="/ask-a-question" :class="addNavClasses('askAQuestion')">
                        <div class="d-flex align-center justify-center flex-column">
                            <v-img                         
                                width="30"
                                height="30"                        
                                src="/general/ic_question_nav.png"
                            ></v-img>
                            <span class="mt-1">Ask a Question</span>
                        </div>                    
                </v-btn>
                <!-- <v-btn text to="/faq" class="playfair-display" :class="addNavClasses('faq')">
                    FAQ
                </v-btn> -->

            </v-toolbar-items>
            
            <v-spacer></v-spacer>
            <v-toolbar-items class="py-0 my-0">
                
                <div class="d-flex align-center">
                    <v-btn 
                        text 
                        to="/patient-login" 
                        v-if="!userInfo" 
                        class="primaryVariant--text" 
                        :x-small="$vuetify.breakpoint.smAndDown"
                        :medium="$vuetify.breakpoint.mdAndUp"
                        style="border:1px solid #00ccff;"
                    >
                        <v-icon small class="ma-0 pa-0 mr-1">mdi-login</v-icon>
                        Login/Register
                    </v-btn>
                </div>

                <div class="fill-height d-flex align-center">
                    <v-btn text to="/for-providers" class="playfair-display hidden-md-and-down">
                        For Providers
                    </v-btn>
                </div>
                <div class="fill-height d-flex align-center">
                    <v-menu offset-y v-if="userInfo">
                        <template v-slot:activator="{ on }">
                            <v-btn text v-on="on" v-if="userInfo">
                                <div>
                                    <div class="d-flex flex-column">
                                        <span>{{ userInfo.name }}</span>
                                        <!-- <span class="font-10">{{ moment().tz(timezone).format('z') }}</span> -->
                                    </div>                          
                                </div>
                                                            
                                <v-icon right>mdi-chevron-down</v-icon>
                            </v-btn>
                        </template>
                        
                        <v-list>
                            <v-list-item
                            class="menu-title-container"
                                    @click="goToPatientPortalMain(patientLinkUtils.myAppointments())">
                                <v-list-item-title class="menu-title">My Appointments</v-list-item-title>
                            </v-list-item>
                            <v-list-item
                            class="menu-title-container"
                            @click="goToPatientPortalMain(patientLinkUtils.myMedicalRecords())">
                                    
                                <v-list-item-title class="menu-title">My Medical Records</v-list-item-title>
                            </v-list-item>
                            <v-list-item
                            class="menu-title-container"
                            @click="goToPatientPortalMain(patientLinkUtils.myQuestions())">
                                    
                                <v-list-item-title class="menu-title">My Questions</v-list-item-title>
                            </v-list-item>
                            <v-list-item
                            class="menu-title-container"
                                    @click="goToPatientPortalMain(patientLinkUtils.myProfile())">
                                <v-list-item-title class="menu-title">My Profile</v-list-item-title>
                            </v-list-item>

                            <v-list-item
                            class="menu-title-container"
                                    @click="goToPatientPortalMain(patientLinkUtils.updateProfile())">
                                <v-list-item-title class="menu-title">Update Profile</v-list-item-title>
                            </v-list-item>
                            <v-divider></v-divider>                                               
                        
                            <v-list-item                        
                                    class="playfair-display menu-title-container"
                                    to="/search-doctor?clinic=1">
                                <v-list-item-title class="menu-title">Clinic Consultation</v-list-item-title>
                                
                            </v-list-item>
                            <v-list-item
                                    class=" playfair-display menu-title-container"
                                    to="/video-consultation">
                                <v-list-item-title class="menu-title">Video Consultation</v-list-item-title>
                                
                            </v-list-item>
                            <v-list-item
                                    class=" playfair-display menu-title-container"
                                    to="/faq">
                                <v-list-item-title class="menu-title">FAQs</v-list-item-title>
                                
                            </v-list-item>
                            <v-list-item
                                    class="hidden-lg-and-up playfair-display menu-title-container"
                                    @click="goTo('forProviders')">
                                <v-list-item-title class="menu-title">For Providers</v-list-item-title>
                            </v-list-item>
                            <v-list-item
                                    class="hidden-lg-and-up playfair-display menu-title-container"
                                    @click="goTo('askAQuestion')">
                                <v-list-item-title class="menu-title">Ask a Question</v-list-item-title>
                            </v-list-item>
                            <!-- <v-list-item
                                    class="hidden-lg-and-up playfair-display"
                                    @click="goTo('faq')">
                                <v-list-item-title class="menu-title">FAQ</v-list-item-title>
                            </v-list-item> -->

                            <v-list-item
                                    class="playfair-display menu-title-container"
                                    @click="logout">
                                <v-list-item-title class="menu-title">Logout</v-list-item-title>
                            </v-list-item>
                            <v-divider></v-divider>                        
                            <v-list-item
                            style="min-height:30px;"
                                class="playfair-display"
                            >
                                <div style="font-size:0.7rem">
                                    Your Timezone is in <b>{{ moment().tz($store.getters.timezone).format('z') }}</b>.
                                </div>
                            </v-list-item>
                            

                        </v-list>
                    </v-menu>


                    <v-menu offset-y v-if="!userInfo">
                        <template v-slot:activator="{ on }">
                            <v-btn text v-on="on" icon class="hidden-lg-and-up">
                                <v-icon>mdi-menu</v-icon>
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-item
                                    class="hidden-md-and-up playfair-display menu-title-container"
                                    to="/search-doctor?clinic=1">
                                <v-list-item-title class="menu-title">Clinic Consultation</v-list-item-title>
                            </v-list-item>
                            <v-list-item
                                    class="hidden-md-and-up playfair-display menu-title-container"
                                    to="/video-consultation">
                                <v-list-item-title class="menu-title">Video Consultation</v-list-item-title>
                                
                            </v-list-item>
                            <v-list-item
                                    class="hidden-lg-and-up playfair-display menu-title-container"
                                    @click="goTo('forProviders')">
                                <v-list-item-title class="menu-title">For Providers</v-list-item-title>
                            </v-list-item>
                            <v-list-item
                                    class="hidden-lg-and-up playfair-display menu-title-container"
                                    @click="goTo('askAQuestion')">
                                <v-list-item-title class="menu-title">Ask a Question</v-list-item-title>
                            </v-list-item>
                            <!-- <v-list-item
                                    class="hidden-lg-and-up playfair-display"
                                    @click="goTo('faq')">
                                <v-list-item-title class="menu-title">FAQ</v-list-item-title>
                            </v-list-item> -->
                        </v-list>
                    </v-menu>
                </div>
            </v-toolbar-items>
        </v-container>
        </v-app-bar>
                
        
            <v-content style="">
                <router-view :style="$route.name=='patientLogin' ? 'height:100%' : ''" :key="$route.fullPath"></router-view>
            </v-content>
            
            <v-alert
                    v-if="$vuetify.breakpoint.mdAndUp"
                    style="position:fixed;bottom:0;left:50%;transform:translateX(-50%);z-index:1000; border-radius:0px"
                    v-model="cookieAlert"
                    border="left"
                    close-text="Close Alert"
                    color="blueBg"
                    class="py-2 my-0"
                    dark                    
                >
                <v-row align="center">
                    <v-col class="grow darkergray--text">
                        This website uses cookies to ensure you get the best experience on our website.
                    </v-col>
                    <v-col class="shrink">
                        <v-btn @click="dismissCookieAlert">Got it</v-btn>
                    </v-col>
                </v-row>
                                        
        </v-alert>
        <v-alert
                    v-else
                    style="position:fixed;bottom:0;width:75%;z-index:1000;left:0%;font-size:12px; border-radius:0px"
                    v-model="cookieAlert"                    
                    close-text="Close Alert"
                    color="blueBg"
                    class="py-2 mb-6 rounded-0"
                    dark                    
                >
                <v-row align="center">
                    <v-col class="grow darkergray--text">
                        This website uses cookies to ensure you get the best experience on our website.
                    </v-col>
                    <v-col class="shrink">
                        <v-btn @click="dismissCookieAlert">OK</v-btn>
                    </v-col>
                </v-row>
                                        
        </v-alert>
        <v-footer id="footer" class="secondaryVariant">
            <v-container class="py-0 pt-8">
                <v-row>
                    <v-col cols="12" sm="12" md="3" class="ma-0">
                        <v-img contain src="/general/logo-footer.svg" :max-width="$vuetify.breakpoint.mdAndUp ? '240px' : '150px'"></v-img>                           
                        <div>
                            <div class="mt-4 font-13 white--text weight-extralight" style="line-height:1.8;">
                                Access video consultation with India’s top doctors on the HealthyAlways app. Connect with doctors online, available 24/7, from the comfort of your home.
                            </div>
                        </div>                               
                        <div class="mt-4">
                            <v-icon medium class="mr-4 white--text" @click="openFacebook()">mdi-facebook</v-icon>
                            <v-icon medium class="mr-4 white--text" @click="openTwitter()">mdi-twitter</v-icon>
                            <v-icon medium class="mr-4 white--text" @click="openLinkedin()">mdi-linkedin</v-icon>
                            <v-icon medium class="white--text" @click="openYoutube()">mdi-youtube</v-icon>
                        </div>
                    </v-col>                                    
                    <v-col cols="12" sm="12" offset-md="1" md="2">
                            <span class="white--text font-14 weight-medium">
                                Quick Links
                            </span>                                                        
                            <v-list dense color="secondaryVariant" class="mt-2" flat>                                
                                <v-list-item-group>
                                    <v-list-item dense class="footer_item" link to="/" >                                        
                                            <span class="white--text font-13 weight-extralight">Home</span>                                        
                                    </v-list-item>
                                    <v-list-item class="footer_item" to="/ask-a-question" >                                        
                                            <span class="white--text font-13 weight-extralight">Ask a Question</span>                                        
                                    </v-list-item>
                                    <v-list-item class="footer_item" to="/faq" >                                        
                                            <span class="white--text font-13 weight-extralight">Faqs</span>                                        
                                    </v-list-item>
                                </v-list-item-group>
                            </v-list>                                                        
                    </v-col>
                    <v-col cols="12" sm="12" md="2">
                            <span class="white--text font-14 weight-medium">
                                For Patient
                            </span>                                                        
                            <v-list dense color="secondaryVariant" class="mt-2" flat>                                
                                <v-list-item-group>
                                    <v-list-item dense class="footer_item" link to="/search-doctor?clinic=1">                                        
                                            <span class="white--text font-13 weight-extralight">Clinic Consultation</span>                                        
                                    </v-list-item>
                                    <v-list-item class="footer_item" link to="/video-consultation">                                        
                                            <span class="white--text font-13 weight-extralight">Video Consultation</span>                                        
                                    </v-list-item>                                    
                                    <v-list-item class="footer_item" link href="/#patient-app">
                                            <span class="white--text font-13 weight-extralight">Patient App</span>                                        
                                    </v-list-item>                                    
                                </v-list-item-group>
                            </v-list>                                                        
                    </v-col>
                    <v-col cols="12" sm="12" md="2">
                            <span class="white--text font-14 weight-medium">
                                For Provider
                            </span>                                                        
                            <v-list dense color="secondaryVariant" class="mt-2" flat>                                
                                <v-list-item-group>
                                    <v-list-item dense class="footer_item" link to="/for-providers">                                        
                                            <span class="white--text font-13 weight-extralight">Doctor+</span>                                        
                                    </v-list-item>
                                    <v-list-item class="footer_item" link href="/for-providers#provider-app">                                        
                                            <span class="white--text font-13 weight-extralight">Doctor+ App</span>                                        
                                    </v-list-item>                                    
                                </v-list-item-group>
                            </v-list>                                                        
                    </v-col>

                    <v-col cols="12" sm="12" md="2">
                            <span class="white--text font-14 weight-medium">
                                More
                            </span>                                                        
                            <v-list dense color="secondaryVariant" class="mt-2" flat>                                
                                <v-list-item-group>
                                    <v-list-item dense class="footer_item" link to="/privacy-policy">                                        
                                            <span class="white--text font-13 weight-extralight">Privacy Policy</span>
                                    </v-list-item>
                                    <v-list-item class="footer_item" link href="/refund-policy">                                        
                                            <span class="white--text font-13 weight-extralight">Refund Policy</span>
                                    </v-list-item>                                    
                                    <v-list-item class="footer_item" link href="/terms-and-conditions">                                        
                                            <span class="white--text font-13 weight-extralight">Terms and Conditions</span>
                                    </v-list-item>                                    
                                </v-list-item-group>
                            </v-list>                                                        
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-divider style="height:0.1px !important;" class="white"></v-divider>
                    </v-col>                    
                    <v-col cols="12" class="text-center">
                        <span class="white--text font-14 weight-light">Copyright © {{ moment().format('YYYY') }} All Rights Reserved | HealthyAlways</span>                        
                    </v-col>                   
                </v-row>
            </v-container>
        </v-footer>
        <v-snackbar              
            top 
            right 
            v-model="showSnackbar" 
            :color="snackbar.color"
        >
            {{snackbar.message}}
        </v-snackbar>
    </v-app>
</template>

<script>
    import {mapGetters} from 'vuex';    
    export default {
        name: 'App',
        computed: {
            ...mapGetters([
                'accessToken',
                'userInfo',
                'timezone',
                'snackbar'
            ]),
        },
        mounted() {                        
            
            var shouldShowCookieAlert = localStorage.getItem('show_cookie_alert', true);
            if(shouldShowCookieAlert == undefined)
                this.cookieAlert = true
            else
                this.cookieAlert = shouldShowCookieAlert == "false" ? false : true

            if(this.$route.query.logout && this.$route.query.logout == 1){
                
                this.logout()
            }        
            else{
                this.axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
                this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('accessToken')
                this.fetchUserInfo()
            }
            
            
        },
        data: () => ({
            showSnackbar:false,
            cookieAlert:true
        }),
        methods: {
            dismissCookieAlert(){
                localStorage.setItem('show_cookie_alert', false);                
                this.cookieAlert = false
            },
            openFacebook(){
                window.open("https://www.facebook.com/HealthyAlways/")
            },
            openTwitter(){
                window.open("https://twitter.com/HealthyAlways1")
            },
            openLinkedin(){
                window.open("https://www.linkedin.com/company/healthyalways-com/")
            },
            openYoutube(){
                window.open("https://www.youtube.com/user/healthyalwaysdr")
            },
            goTo(routeName) {
                this.$router.push({name: routeName});
            },
            logout() {
                this.$store.dispatch('userLogout')
                window.location.href = process.env.VUE_APP_URL;
            },
            fetchUserInfo() {
                if (this.userInfo && this.userInfo.id) {                    
                    
                    this.axios.get(`${process.env.VUE_APP_API_URL}/api/patients/${this.userInfo.id}`)
                        .then((response) => {
                            var tz = response.data.data.timezone
                            //this.$store.dispatch('storeUserInfo', response.data.data)
                            this.$store.dispatch('storeTimezone', tz)  
                        })
                        .catch((error) => {
                            console.log(error)
                        })
                }
            },
            addNavClasses(name){

                if(name === 'clinic' && this.$route.name == 'searchDoctor' && this.$route.query.clinic == 1)
                    return 'active-menu'
                else if(name === 'video'){
                  if(this.$route.name == 'searchDoctor' && this.$route.query.video == 1)
                        return 'active-menu'
                    else if(this.$route.name == 'videoConsultation'){
                        return 'active-menu'
                    }
                }                
                else if(name === 'faq' && this.$route.name == 'faq')
                    return 'active-menu'
                else if(name === 'askAQuestion' && this.$route.name == 'askAQuestion')
                    return 'active-menu'
            }
        },
        watch:{
            $route(){
                window.scrollTo(0,0);
                // if(this.$route.name == 'patientLogin'){
                //     document.querySelector('html').style.overflow = 'hidden'
                // }
                // else{
                //     document.querySelector('html').style.overflow = null
                // }
            }
        },
        created () {
            this.$store.subscribe((mutation, state) => {
                if (mutation.type === 'showSnackbar') {                    
                    this.snackbar.message = state.snackbar.message
                    this.snackbar.color = state.snackbar.color
                    this.showSnackbar = true
                }
            })
        },
    };
</script>
<style>
.cursor-pointer {
  cursor: pointer;
}
</style>
<style scoped>
    footer .v-icon:hover {
        color: #F76056 !important;
    }
</style>